import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import CasesForm from './CasesForm';
import Notification, { notify } from '../../../common/Notification/Notification';

storiesOf('Advanced Search/Initial Forms/All Courts/Cases', module)
  .add('View', () => <CasesForm onSubmit={action('searchGeneral')} onReset={action('resetGeneralSearch')} />)
  .add('Search error', () => (
    <div>
      <Notification />
      <CasesForm
        onSubmit={(...args) => {
          notify.error('Failed to return Advanced Search results');
          action('searchGeneral')(...args);
        }}
        onReset={action('resetGeneralSearch')}
      />
    </div>
  ));



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/allCourts/CasesForm.stories.jsx